import { createRequest } from '@shared/services';

export async function getPromoCoupon() {
    const request = createRequest<GetCouponResponse>({
        url: '/promo/coupon',
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function getPromoCouponById(promoId: string) {
    const request = createRequest<GetCouponResponse>({
        url: `/promo/coupon/${promoId}`,
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function postPromoCoupon<T>(payload: T) {
    const request = createRequest<PostCouponResponse>({
        url: '/promo/coupon',
        method: 'POST',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function getPromoCouponCollection(params: { shipping_profile_id: string }) {
    const request = createRequest<GetBuyerCouponCollectionResponse>({
        url: '/promo/coupon/collection',
        method: 'GET',
        withAuthorization: true,
        params,
    });

    return request.execute();
}

export async function postCouponClaim(payload: {
    code: string;
    shipping_profile_id: string;
}) {
    const { code, shipping_profile_id } = payload;

    const request = createRequest<PostBuyerCouponClaimResponse>({
        url: `/promo/coupon/claim/${code}`,
        method: 'POST',
        withAuthorization: true,
        data: { shipping_profile_id },
    });

    return request.execute();
}

export async function putPromoCouponById<T>(payload: T, promoId: string) {
    const request = createRequest<PostCouponResponse>({
        url: `/promo/coupon/${promoId}`,
        method: 'PUT',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}

export async function deletePromoGiveawayById(promoId: string) {
    const request = createRequest<PostCouponResponse>({
        url: `/promo/giveaway/${promoId}`,
        method: 'DELETE',
        withAuthorization: true,
    });

    return request.execute();
}

export async function deletePromoPromoById(promoId: string) {
    const request = createRequest<PostCouponResponse>({
        url: `/promo/promo/${promoId}`,
        method: 'DELETE',
        withAuthorization: true,
    });

    return request.execute();
}

export async function deletePromoCouponById(promoId: string) {
    const request = createRequest<PostCouponResponse>({
        url: `/promo/coupon/${promoId}`,
        method: 'DELETE',
        withAuthorization: true,
    });

    return request.execute();
}
